import * as React from "react";

function SvgIcons8AndroidOs(props, ref) {
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fill="#7cb342"
        d="M12 29c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2v9zm28 0c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2v9zM22 40c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2v9zm8 0c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2v9z"
      />
      <path
        fill="#7cb342"
        d="M14 18v15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V18H14zM24 8c-6 0-9.7 3.6-10 8h20c-.3-4.4-4-8-10-8zm-4 5.6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1c0 .5-.4 1-1 1zm8 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1c0 .5-.4 1-1 1z"
      />
      <path
        fill="#7cb342"
        d="M28.3 10.5c-.2 0-.4-.1-.6-.2-.5-.3-.6-.9-.3-1.4l1.7-2.5c.3-.5.9-.6 1.4-.3.5.3.6.9.3 1.4L29.1 10c-.1.3-.4.5-.8.5zm-9-.4c-.3 0-.7-.2-.8-.5l-1.3-2.1c-.3-.5-.2-1.1.3-1.4.5-.3 1.1-.2 1.4.3l1.3 2.1c.3.5.2 1.1-.3 1.4-.2.1-.4.2-.6.2z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8AndroidOs);
